var exports = {
  "x": "ExpiryFootnote.module__footnote___eXAxWl",
  "m": "ExpiryFootnote.module__inlineFootnote___eXAxWl",
};

module.exports = exports;
